module.exports = __webpack_public_path__ + "static/flags/VQ-d37a8ef81a9ec6c92eeaf010833a232c.gif";